import React from 'react';
import { Card, CardBody, CardTitle, CardText, Button, CardFooter } from 'reactstrap';

const BuildAithAiCard = ({ title, description, handleSelect }) => {

//   function truncateString(str) {
//     if (str.length > 160) {
//         return str.slice(0, 160) + "...";
//     } else {
//         return str;
//     }
// }

  function truncateString(str) {
    if (str.length > 140) {
        let truncatedStr = str.slice(0, 140);
        let lastSpaceIndex = truncatedStr.lastIndexOf(" ");
        if (lastSpaceIndex !== -1) {
            truncatedStr = truncatedStr.slice(0, lastSpaceIndex);
        }
        return truncatedStr + "...";
    } else {
        return str;
    }
  }

  return (
    <Card style={{height:"100%"}} className="sharepage_item_card p-1" onClick={handleSelect}>
      <div className={"text-center p-2"}>
        <div>
        <div className="share_page_card_heading">{title}</div>
        </div>

        <div className="ml-0 mt-4 trivvy_samples_card_desc" style={{color:"black"}}>{truncateString(description)}</div>
     
      
       
      </div>
      <CardFooter className="text-center insert_prompt_footer p-2">
      <div className="cursor-pointer text-info">
            Insert as prompt
        </div>
      </CardFooter>
    </Card>
  );
};

export default BuildAithAiCard;
